import _classCallCheck from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/webwork/Documents/JSGitHub/baraka_erp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * DevExtreme (esm/ui/text_box/texteditor_button_collection/index.js)
 * Version: 21.2.4
 * Build date: Mon Dec 06 2021
 *
 * Copyright (c) 2012 - 2021 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import $ from "../../../core/renderer";
import CustomButton from "./custom";
import { extend } from "../../../core/utils/extend";
import { find } from "../../../core/utils/array";
import errors from "../../widget/ui.errors";
var TEXTEDITOR_BUTTONS_CONTAINER_CLASS = "dx-texteditor-buttons-container";

function checkButtonInfo(buttonInfo) {
  (function () {
    if (!buttonInfo || "object" !== typeof buttonInfo || Array.isArray(buttonInfo)) {
      throw errors.Error("E1053");
    }
  })();

  (function () {
    if (!("name" in buttonInfo)) {
      throw errors.Error("E1054");
    }
  })();

  (function () {
    var name = buttonInfo.name;

    if ("string" !== typeof name) {
      throw errors.Error("E1055");
    }
  })();

  (function () {
    var location = buttonInfo.location;

    if ("location" in buttonInfo && "after" !== location && "before" !== location) {
      buttonInfo.location = "after";
    }
  })();
}

function checkNamesUniqueness(existingNames, newName) {
  if (-1 !== existingNames.indexOf(newName)) {
    throw errors.Error("E1055", newName);
  }

  existingNames.push(newName);
}

function isPredefinedButtonName(name, predefinedButtonsInfo) {
  return !!find(predefinedButtonsInfo, function (info) {
    return info.name === name;
  });
}

var TextEditorButtonCollection = /*#__PURE__*/function () {
  function TextEditorButtonCollection(editor, defaultButtonsInfo) {
    _classCallCheck(this, TextEditorButtonCollection);

    this.buttons = [];
    this.defaultButtonsInfo = defaultButtonsInfo;
    this.editor = editor;
  }

  _createClass(TextEditorButtonCollection, [{
    key: "_compileButtonInfo",
    value: function _compileButtonInfo(buttons) {
      var _this = this;

      var names = [];
      return buttons.map(function (button) {
        var isStringButton = "string" === typeof button;

        if (!isStringButton) {
          checkButtonInfo(button);
        }

        var isDefaultButton = isStringButton || isPredefinedButtonName(button.name, _this.defaultButtonsInfo);

        if (isDefaultButton) {
          var defaultButtonInfo = find(_this.defaultButtonsInfo, function (_ref) {
            var name = _ref.name;
            return name === button || name === button.name;
          });

          if (!defaultButtonInfo) {
            throw errors.Error("E1056", _this.editor.NAME, button);
          }

          checkNamesUniqueness(names, button);
          return defaultButtonInfo;
        } else {
          var name = button.name;
          checkNamesUniqueness(names, name);
          return extend(button, {
            Ctor: CustomButton
          });
        }
      });
    }
  }, {
    key: "_createButton",
    value: function _createButton(buttonsInfo) {
      var Ctor = buttonsInfo.Ctor,
          options = buttonsInfo.options,
          name = buttonsInfo.name;
      var button = new Ctor(name, this.editor, options);
      this.buttons.push(button);
      return button;
    }
  }, {
    key: "_renderButtons",
    value: function _renderButtons(buttons, $container, targetLocation) {
      var _this2 = this;

      var $buttonsContainer = null;
      var buttonsInfo = buttons ? this._compileButtonInfo(buttons) : this.defaultButtonsInfo;
      buttonsInfo.forEach(function (buttonsInfo) {
        var _buttonsInfo$location = buttonsInfo.location,
            location = _buttonsInfo$location === void 0 ? "after" : _buttonsInfo$location;

        if (location === targetLocation) {
          _this2._createButton(buttonsInfo).render(function () {
            $buttonsContainer = $buttonsContainer || $("<div>").addClass(TEXTEDITOR_BUTTONS_CONTAINER_CLASS);
            "before" === targetLocation ? $container.prepend($buttonsContainer) : $container.append($buttonsContainer);
            return $buttonsContainer;
          }());
        }
      });
      return $buttonsContainer;
    }
  }, {
    key: "clean",
    value: function clean() {
      this.buttons.forEach(function (button) {
        return button.dispose();
      });
      this.buttons = [];
    }
  }, {
    key: "getButton",
    value: function getButton(buttonName) {
      var button = find(this.buttons, function (_ref2) {
        var name = _ref2.name;
        return name === buttonName;
      });
      return button && button.instance;
    }
  }, {
    key: "renderAfterButtons",
    value: function renderAfterButtons(buttons, $container) {
      return this._renderButtons(buttons, $container, "after");
    }
  }, {
    key: "renderBeforeButtons",
    value: function renderBeforeButtons(buttons, $container) {
      return this._renderButtons(buttons, $container, "before");
    }
  }, {
    key: "updateButtons",
    value: function updateButtons(names) {
      this.buttons.forEach(function (button) {
        if (!names || -1 !== names.indexOf(button.name)) {
          button.update();
        }
      });
    }
  }]);

  return TextEditorButtonCollection;
}();

export { TextEditorButtonCollection as default };